const PageNotFound = () => {
  return (
    <div className="PageNotFound">
      <h1 className="text-dark mx-auto">404 Page not found</h1>
    </div>
  );
};

export default PageNotFound;
